import Vue from 'vue';
import VueRouter from 'vue-router';
import VuexRouterSync from 'vuex-router-sync';
import routes from './routes';
import store from '../store';
// import { datadogRum } from '@datadog/browser-rum';

Vue.use(VueRouter);

export const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  const authRoutes = ['/login', '/register', '/forgot', '/reset'];
  const isAuthenticated = store.state.auth.authenticated;
  const fromAuthRoute = authRoutes.includes(from.path);

  if (!isAuthenticated && to.path === '/login' && to.params.type === 'logout' && fromAuthRoute) {
    const targetRoute = { name: from.name, params: from.params, query: from.query };
    if (from.path === '/reset' && !from.query.user_name) {
      targetRoute.name = 'forgot';
    }
    if (to.name !== targetRoute.name && JSON.stringify(to.query) !== JSON.stringify(targetRoute.query)) {
      router.push(targetRoute);
    }
  } else if (isAuthenticated && authRoutes.includes(to.path)) {
    document.location.href = '/';
  } else {
    next();
  }
});

// Update the datadog view name
router.afterEach((to) => {
  if (to.fullPath === '/register') {
    gtag('event', 'sign_up_redirects', {
      send_to: "G-" + process.env.GTAG 
    });
  }
});

Vue.router = router;
VuexRouterSync.sync(store, router);

export default {
  router,
};



// WEBPACK FOOTER //
// ./src/routes/index.js